<div class="create--wrapper">
    <div class="create--wrapper__container">
        <app-logo></app-logo>
        <h1>Cyber Wallet</h1>
        <ng-container *ngIf="!(error$ | async)">
            <app-loading-spinner style="margin-top: 16px" [has-text]="false"></app-loading-spinner>
            <div class="text--center">
                <p>Creating wallet</p>
                <p style="margin-top: 4px">Please wait</p>
            </div>
        </ng-container>
        <ng-container *ngIf="error$ | async">
            <p class="text--size-s text--center input-error">
                {{ error$ | async }}
            </p>
            <button class="btn" (click)="createWalletAutomatically()">
                Retry
            </button>
        </ng-container>
    </div>
</div>
